export default {
  methods: {
    toFixedTwo: function (number) {
      return parseFloat(number).toFixed(2)
    }
  }
}
